export function ConvexProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
